import React, {useEffect, useMemo, useState} from 'react'
import ModalContext from '@/components/ModalContext/ModalContext'
import useAcceptModal from '@/hooks/modalAccept'
import useNotification from '@/hooks/notification'
import Congratulations from '@/components/AcceptModal/Congratulations'

interface ModalProviderProps {
  children: any
}

export enum NotificationType {
  CHANGE_USER_STATUS = 'CHANGE_USER_STATUS',
}

const ModalProvider = ({children}: ModalProviderProps) => {
  const [modal, setModal] = useState<React.ReactNode | null>(null)
  const hideModal = () => setModal(null)
  const modalIsShow = useMemo(() => modal !== null, [modal])
  const {setAcceptModal} = useAcceptModal()
  const {lastMessage} = useNotification()

  useEffect(() => {
    if (modal) {
      const container = document.getElementById('main')
      if (container) {
        container.style.filter = 'blur(5px)'
      }
    } else {
      const container = document.getElementById('main')
      if (container) {
        container.style.filter = 'none'
      }
    }
  }, [modal])

  useEffect(() => {
    if (!lastMessage) return
    switch (lastMessage.data?.type) {
      case NotificationType.CHANGE_USER_STATUS:
        setAcceptModal(
          <Congratulations
            status={lastMessage.data.rule_name}
            count={lastMessage.data.land_count}
          />
        )
    }
  }, [lastMessage])

  return (
    <ModalContext.Provider
      value={{
        modal,
        setModal,
        hideModal,
        modalIsShow,
      }}>
      {modal}
      {children}
    </ModalContext.Provider>
  )
}

export default ModalProvider
